// extracted by mini-css-extract-plugin
export var label = "_gx-2";
export var slideContainer = "_gx-0";
export var slider = "_gx-1";